module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og nordsamisk_primærlogo_neg(hvit).acc0e9e1.png";